import { Component, h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'
import BadgeSelector from '../badges/BadgeSelector'
import axios from 'axios'
import tracker from '../../components/tracker/publish'
import { BadgeList } from "./index";

interface Props {
  userId: number,
  userName: string,
  userRole: string,
  awarderId: number,
  awarderUsername: string,
  awarderRole: string
}

interface State {
  badgesList: BadgeList | null,
  selectedBadge: string | null,
  isModalOpen: boolean,
  error?: string
}

class AwardBadgeModal extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      badgesList: null,
      selectedBadge: null,
      isModalOpen: true
    }
    this.awardBadge = this.awardBadge.bind(this)
    this.onBadgeSelected = this.onBadgeSelected.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.trackBadgeAwardedEvent = this.trackBadgeAwardedEvent.bind(this)
  }

  async componentDidMount () {
    const response = await axios.get('/settings/badge/getBadgesList')
    this.setState({ badgesList: response.data })
  }

  async awardBadge () {
    const { selectedBadge } = this.state
    const { userName } = this.props

    if (!selectedBadge) {
      this.setState({error: 'Please select a badge'})
      return
    }

    try {
      await axios.post('/settings/badge/award', {
        badgeId: selectedBadge,
        userNames: [userName]
      }).then(() => {
        this.trackBadgeAwardedEvent(selectedBadge)
        this.closeModal()
        window.location.reload()
      })
    } catch (e) {}
  }

  trackBadgeAwardedEvent (selectedBadge: string) {
    const { badgesList } = this.state
    const { awarderId, awarderUsername, awarderRole, userId, userName, userRole } = this.props

    if (!badgesList) return

    const awardedBadge = badgesList.find((badge) => badge.id.toString() === selectedBadge)

    if (!awardedBadge) return

    tracker.trackEvent('userevent', {
      type: 'Badge Awarded',
      badgeId: awardedBadge.id,
      badgeName: awardedBadge.title,
      badgeDescription: awardedBadge.description,
      awarderId: awarderId,
      awarderUsername: awarderUsername,
      awarderRole: awarderRole,
      awardedId: userId,
      awardedUsername: userName,
      awardedRole: userRole
    })
  }

  onBadgeSelected (badgeId: string) {
    this.setState({ selectedBadge: badgeId, error: undefined })
  }

  closeModal () {
    this.setState({ isModalOpen: false })
  }

  render (props: Props, state: State) {
    if (!state.badgesList) return null

    return (
      <Modal isOpen={state.isModalOpen}>
        <ModalHeader title='Award badge' onClose={() => this.closeModal()} />
        <ModalBody>
          <BadgeSelector
            badges={state.badgesList}
            selected={state.badgesList.find((badge) => badge.id.toString() === state.selectedBadge)}
            onChange={this.onBadgeSelected}
            error={state.error}
          />
        </ModalBody>
        <ModalFooter>
          <ButtonControl title='Award' variant='primary' onClick={() => this.awardBadge()} />
          <ButtonControl title='Cancel' onClick={() => this.closeModal()} />
        </ModalFooter>
      </Modal>
    )
  }
}

export default AwardBadgeModal
